var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "m17.96 1.1729-0.46579-0.46579c-0.39052-0.39052-1.0237-0.39052-1.4142 0l-6.7462 6.7462-6.7462-6.7462c-0.39052-0.39052-1.0237-0.39052-1.4142 0l-0.46579 0.46579c-0.39052 0.39052-0.39052 1.0237 0 1.4142l6.7462 6.7462-6.7462 6.7462c-0.39052 0.39052-0.39052 1.0237 0 1.4142l0.46579 0.46579c0.39052 0.39052 1.0237 0.39052 1.4142 0l6.7462-6.7462 6.7462 6.7462c0.39052 0.39052 1.0237 0.39052 1.4142 0l0.46579-0.46579c0.39052-0.39052 0.39052-1.0237 0-1.4142l-6.7462-6.7462 6.7462-6.7462c0.39052-0.39052 0.39052-1.0237 0-1.4142z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1.0091 0 0 1.0091 -.41797 -.41797)",
    width: "100%",
    height: "100%",
    fill: "#ffffff",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossWhite);
export default __webpack_public_path__ + "static/media/cross-white.547003bff80c42fccb7fe16288206339.svg";
export { ForwardRef as ReactComponent };